import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import {
  Badge, Button, Checkbox, Copy01, DotsVertical, Drawer, Edit01, InfoCircle, Menu, Modal, Plus, Select as SetlistSelect, Settings01, Spinner, TextInput, Toggle, Tooltip, XClose,
} from '@opendate-app/setlist';

import AddOnsTable from "./AddOnsTable";
import AddOnPresetPicker from "./AddOnPresetPicker";
import AddOnMessageTemplates from '../../AddOnMessageTemplates/components/AddOnMessageTemplates';
import SeatingChartCard from './SeatingChartCard';

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

var _ = require('lodash');
import { toast } from 'react-toastify';
const axios = require('axios').default;

import RichEditor from '../../RichEditor/components/RichEditor';
import {EditorState} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import {stateFromHTML} from 'draft-js-import-html';

import Popup from "reactjs-popup";
import {DebounceInput} from 'react-debounce-input';
import Flatpickr from "react-flatpickr";

import CurrencyInput from '../../CurrencyInput/components/CurrencyInput';
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import EditSeatingChartDesigner from './EditSeatingChartDesigner';
import SaveAsTemplateModal from './SaveAsTemplateModal';
import DaySeatMapModal from './DaySeatMapModal';
import { toastError } from '../../../shared/toastHelper';
import PriceBreakoutAccordion from './PriceBreakoutAccordion';
import DynamicPricingSection from './DynamicPricingSection';
import ImageUpload from '../../../shared/ImageUpload';
import AddOnDrawer from './AddOnDrawer';
import {
  addOnIsSeated, canSubmitForm, isSharingInventory, minPerOrderMoreThanMax, parseDateTime, parseFloatFromString, requiredAddOnOptions,
  showActivityOption, visiblePricePoints,
} from './addOnFormHelpers';
import { ACCESSIBLE_SEATING_OPTIONS } from './ticketTypeFormHelpers';

import './TicketDrawer.css';
import './AddOnDrawer.css';

const ADD_ON_DRAWER_FORM_ID = 'add-on-drawer-form';

const AVAILABILITY_OPTIONS = [
  { value: 'Based on show details', label: 'Based on show details' },
  { value: 'Date & Time', label: 'Date & Time' },
];

const SALES_CHANNEL_OPTIONS = [
  { value: 'Everywhere', label: 'Everywhere' },
  { value: 'Online only', label: 'Online only' },
  { value: 'At the door only', label: 'At the door only' },
];

const CHECK_IN_PERIOD_OPTIONS = [
  { value: 'all_time', label: 'All Time' },
  { value: 'daily', label: 'Daily' },
];

const RequiredLabel = ({ children }) => (
  <>
    {children}
    <span className="ticket-drawer-required">&nbsp;*</span>
  </>
);

const LabelWithInfo = ({ tip, children }) => (
  <span className="ticket-drawer-label-with-info">
    {children}
    <Tooltip title={tip} maxWidth={240}>
      <span className="ticket-drawer-info" tabIndex={0} aria-label="More information">
        <InfoCircle width={14} height={14} aria-hidden="true" />
      </span>
    </Tooltip>
  </span>
);

const addOnOptionsPopupContentStyle = {
  "border": "1px solid var(--sl-border-secondary)",
  "borderRadius": "8px",
  "background": "var(--sl-bg-primary)",
  "boxShadow": "var(--sl-shadow-lg)",
  "width": "220px",
  "padding": "12px 16px"
}

const shellHelpTextStyle = { color: "var(--sl-text-tertiary)" };

const shellDividerStyle = {
  "borderTop": "1px solid var(--sl-border-secondary)",
  "marginTop": "20px",
  "marginBottom": "20px"
};

const canChangeAddOnSeatingChart = (confirm, isLoadingDefaultAddOns) => {
  return (
    confirm
      && confirm.can_change_add_on_ticketing_arrangement
      && !isLoadingDefaultAddOns
  )
}

var debouncedDetermineFinalCosts;


const AddOnsTab = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  addOns,
  addOnForForm,
  fetchNewAddOn,
  addOnForFormChanged,
  ticketTypes,
  createAddOn,
  fetchAddOnToEdit,
  deleteAddOn,
  updateAddOn,
  addOnDragged,
  addOnSeatingCharts,
  autoSaveConfirm,
  updateConfirm,
  isEditingAddOnsIntro,
  isEditingAddOnsIntroChanged,
  addOnsIntroEditorState,
  addOnsIntroEditorStateChanged,
  isLoadingDefaultAddOns,
  isLoadingDefaultAddOnsChanged,
  isEditingAddOnsAlertMessage,
  isEditingAddOnsAlertMessageChanged,
  addOnsAlertMessageEditorState,
  addOnsAlertMessageEditorStateChanged,
  showActivities,
  manualTaxes,
  manualTaxShouldBeChecked,
  addOnAdded,
  seatingChartEvents,
  reloadAddOns,
  confirmChanged,
  addOnSeatingChartEvent,
  addOnSeatingChartEventChanged,
  seatingChartEventsChanged = () => {},
  canEditSeatingChart,
  reasonWeCannotEditSeatingChart,
  addOnsIntroTemplates,
  addOnsAlertMessageTemplates,
  addOnsIntroTemplateDraft,
  addOnsAlertMessageTemplateDraft,
  addOnMessageTemplateChanged,
  createAddOnMessageTemplate,
  deleteAddOnMessageTemplate
}) => {
  const standardAddOns = addOns.filter((addOn) => !addOnIsSeated(addOn));
  const seatedAddOns = addOns.filter((addOn) => addOnIsSeated(addOn));
  const [duplicatingAddOnId, setDuplicatingAddOnId] = useState(null);
  const [isSavingDuplicateAddOn, setIsSavingDuplicateAddOn] = useState(false);
  const [pricePointToRemove, setPricePointToRemove] = useState(null);
  const [showDesigner, setShowDesigner] = useState(false);
  const [showSaveTemplate, setShowSaveTemplate] = useState(false);
  const [dayMapModal, setDayMapModal] = useState(null);
  const [dayMapToRemove, setDayMapToRemove] = useState(null);
  const [isSavingDayMap, setIsSavingDayMap] = useState(false);

  const addOnEventChartClone = addOnSeatingChartEvent?.event_chart_clone;

  const onSelectSeatingChart = async (seatingChart) => {
    isLoadingDefaultAddOnsChanged(true);

    const params = {
      seating_chart_event: {
        seating_chart_id: seatingChart.id,
        context: "add_on"
      }
    };

    try {
      const response = addOnSeatingChartEvent?.id ?
        await axios.patch(`/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events/${addOnSeatingChartEvent.id}`, params) :
        await axios.post(`/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events`, params);

      addOnSeatingChartEventChanged(response.data.seating_chart_event);
      reloadAddOns();
    } catch (error) {
      isLoadingDefaultAddOnsChanged(false);
      toastError(error.response?.data?.errors?.base?.[0] || "Failed to update seating chart");
    }
  };


  const destroySeatingChartEvent = async () => {
    isLoadingDefaultAddOnsChanged(true);
    try {
      await axios.delete(`/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events/${addOnSeatingChartEvent.id}`);
      addOnSeatingChartEventChanged(null);
      reloadAddOns();
    } catch (error) {
      isLoadingDefaultAddOnsChanged(false);
      toastError("Failed to clear seating chart");
    };
  }

  const seatingChartEventsPath = `/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events`;

  const saveDayMap = async ({ name, seatingChartId }) => {
    setIsSavingDayMap(true);
    try {
      if (dayMapModal.seatingChartEvent) {
        const response = await axios.patch(`${seatingChartEventsPath}/${dayMapModal.seatingChartEvent.id}`, { seating_chart_event: { name } });
        seatingChartEventsChanged(seatingChartEvents.map((e) => e.id === response.data.seating_chart_event.id ? response.data.seating_chart_event : e));
      } else {
        const response = await axios.post(seatingChartEventsPath, { seating_chart_event: { name, seating_chart_id: seatingChartId, context: "festival" } });
        seatingChartEventsChanged([...seatingChartEvents, response.data.seating_chart_event]);
        reloadAddOns();
      }
      setDayMapModal(null);
    } catch (error) {
      toastError(error.response?.data?.errors?.base?.[0] || "Couldn't save the day seat map");
    } finally {
      setIsSavingDayMap(false);
    }
  };

  const removeDayMap = async () => {
    setIsSavingDayMap(true);
    try {
      await axios.delete(`${seatingChartEventsPath}/${dayMapToRemove.id}`);
      seatingChartEventsChanged(seatingChartEvents.filter((e) => e.id !== dayMapToRemove.id));
      reloadAddOns();
      setDayMapToRemove(null);
    } catch (error) {
      toastError(error.response?.data?.errors?.base?.[0] || "Couldn't remove the day seat map");
    } finally {
      setIsSavingDayMap(false);
    }
  };

  const duplicateAddOn = (csrfToken, team, addOnId) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    setIsSavingDuplicateAddOn(true);

    return axios.post(`/teams/${team.id}/add_ons/${addOnId}/dup_with_shared_inventory`, {})
      .then(({ data }) => {
        addOnAdded(data);
      })
      .catch((error) => {
        toast.error("Something went wrong. Try again.", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      }).finally(() => {
        setDuplicatingAddOnId(null);
        setIsSavingDuplicateAddOn(false);
      });
  };

  useEffect(() => {
    if (isEditingAddOnsIntro) {
      addOnsIntroEditorStateChanged(EditorState.createWithContent(stateFromHTML(confirm.add_ons_intro)));
    }
  }, [isEditingAddOnsIntro]);

  useEffect(() => {
    if (isEditingAddOnsAlertMessage) {
      addOnsAlertMessageEditorStateChanged(EditorState.createWithContent(stateFromHTML(confirm.add_ons_alert_message)));
    }
  }, [isEditingAddOnsAlertMessage]);

  const saveAddOnsIntro = () => {
    var html = stateToHTML(addOnsIntroEditorState.getCurrentContent());
    var updated = Object.assign({}, confirm, {
      add_ons_intro: html
    });

    updateConfirm(updated);
    autoSaveConfirm(csrfToken, team, updated);
    isEditingAddOnsIntroChanged(false);
  };

  const saveAddOnsAlertMessage = () => {
    var html = stateToHTML(addOnsAlertMessageEditorState.getCurrentContent());
    var updated = Object.assign({}, confirm, {
      add_ons_alert_message: html
    });

    updateConfirm(updated);
    autoSaveConfirm(csrfToken, team, updated);
    isEditingAddOnsAlertMessageChanged(false);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleAddOnImageSelected = (file) => {
    if (addOnForForm.image_preview_url) {
      URL.revokeObjectURL(addOnForForm.image_preview_url);
    }
    
    const previewUrl = URL.createObjectURL(file);
    addOnForFormChanged({
      ...addOnForForm,
      image_file: file,
      image_file_info: {
        name: file.name,
        size: formatFileSize(file.size)
      },
      image_preview_url: previewUrl,
      remove_image: false
    });
  };

  const handleAddOnImageRemove = () => {
    if (addOnForForm.image_preview_url) {
      URL.revokeObjectURL(addOnForForm.image_preview_url);
    }
    addOnForFormChanged({
      ...addOnForForm,
      image_file: null,
      image_file_info: null,
      image_preview_url: null,
      image_url: null,
      has_image: false,
      remove_image: addOnForForm.image_url ? true : false
    });
  };

  const addOnForFormRef = useRef(addOnForForm);
  addOnForFormRef.current = addOnForForm;
  const isAddOnFormOpen = Object.keys(addOnForForm).length > 0;

  const closeAddOnForm = () => {
    if (addOnForForm.image_preview_url) {
      URL.revokeObjectURL(addOnForForm.image_preview_url);
    }
    addOnForFormChanged({});
  };

  const determineFinalCosts = (addOn) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const quotedPricePointIds = visiblePricePoints(addOn.price_points).map((pricePoint) => pricePoint.id);

    const taxableItemsAttrs = (addOn.taxable_items || []).map((taxableItem) => {
      return {...taxableItem, id: ""};
    });

    var params = {
      add_ons: [
        {
          absorb_fees: addOn.absorb_fees,
          round_up: addOn.round_up,
          calendar_event_id: confirm.id,
          price: addOn.base_price_two_decimals ? parseFloatFromString(addOn.base_price_two_decimals) : 0.0,
          taxable_items_attributes: taxableItemsAttrs
        }
      ]
    }

    visiblePricePoints(addOn.price_points).forEach((pricePoint) => {
      params["add_ons"].push({
        absorb_fees: addOn.absorb_fees,
        round_up: addOn.round_up,
        calendar_event_id: confirm.id,
        price: pricePoint.price_two_decimals ? parseFloatFromString(pricePoint.price_two_decimals) : 0.0,
        taxable_items_attributes: taxableItemsAttrs
      });
    });

    return axios.post("/teams/" + team.id + "/add_ons/build_ticket", {
      add_on: params
    })
      .then(({ data }) => {
        const current = addOnForFormRef.current;
        if (Object.keys(current).length === 0 || current.id !== addOn.id) return;

        addOnForFormChanged({
          ...current,
          final_cost: data.card[0]?.final_cost || 0,
          custom_charges: data.card[0]?.custom_charges || 0,
          fees: data.card[0]?.fees || 0,
          organizer_service_fee: data.card[0]?.organizer_service_fee || 0,
          round_up_organizer_fee: data.card[0]?.round_up_organizer_fee || 0,
          opendate_service_fee: data.card[0]?.opendate_service_fee || 0,
          processing_fee: data.card[0]?.processing_fee || 0,
          rebate_fee: data.card[0]?.rebate_fee || 0,
          taxes: data.card[0]?.taxes || 0,
          cash_final_cost: data.cash[0]?.final_cost || 0,
          cash_custom_charges: data.cash[0]?.custom_charges || 0,
          cash_fees: data.cash[0]?.fees || 0,
          cash_organizer_service_fee: data.cash[0]?.organizer_service_fee || 0,
          cash_round_up_organizer_fee: data.cash[0]?.round_up_organizer_fee || 0,
          cash_opendate_service_fee: data.cash[0]?.opendate_service_fee || 0,
          cash_processing_fee: data.cash[0]?.processing_fee || 0,
          cash_rebate_fee: data.cash[0]?.rebate_fee || 0,
          cash_taxes: data.cash[0]?.taxes || 0,
          price_points: [...visiblePricePoints(current.price_points).map((pricePoint) => [pricePoint, quotedPricePointIds.indexOf(pricePoint.id)]).map(([pricePoint, index]) => index === -1 ? pricePoint : ({
            ...pricePoint,
            absorb_fees: current.absorb_fees,
            round_up: current.round_up,
            final_cost: data.card[index + 1]?.final_cost || 0,
            custom_charges: data.card[index + 1]?.custom_charges || 0,
            fees: data.card[index + 1]?.fees || 0,
            organizer_service_fee: data.card[index + 1]?.organizer_service_fee || 0,
            round_up_organizer_fee: data.card[index + 1]?.round_up_organizer_fee || 0,
            opendate_service_fee: data.card[index + 1]?.opendate_service_fee || 0,
            processing_fee: data.card[index + 1]?.processing_fee || 0,
            rebate_fee: data.card[index + 1]?.rebate_fee || 0,
            taxes: data.card[index + 1]?.taxes || 0,
            cash_final_cost: data.cash[index + 1]?.final_cost || 0,
            cash_custom_charges: data.cash[index + 1]?.custom_charges || 0,
            cash_fees: data.cash[index + 1]?.fees || 0,
            cash_organizer_service_fee: data.cash[index + 1]?.organizer_service_fee || 0,
            cash_round_up_organizer_fee: data.cash[index + 1]?.round_up_organizer_fee || 0,
            cash_opendate_service_fee: data.cash[index + 1]?.opendate_service_fee || 0,
            cash_processing_fee: data.cash[index + 1]?.processing_fee || 0,
            cash_rebate_fee: data.cash[index + 1]?.rebate_fee || 0,
            cash_taxes: data.cash[index + 1]?.taxes || 0,
          })), ...(current.price_points || []).filter((pricePoint) => pricePoint._destroy)]
        });
      })
      .catch((error) => {
        toast.error("Failed to calculate add-on costs", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const startShowActivity = showActivities.find(showActivity => {
    return showActivity.id === addOnForForm.start_show_activity_id
  })

  const endShowActivity = showActivities.find(showActivity => {
    return showActivity.id === addOnForForm.end_show_activity_id
  })

  const useDateAndTime = addOnForForm.availability === "Date & Time"

  const showActivityOptions = showActivities.map(showActivity => showActivityOption(showActivity));

  const pricePointsMinDate = useDateAndTime ? addOnForForm.start_time : startShowActivity?.start_time
  const pricePointsMaxDate = useDateAndTime ? addOnForForm.end_time : endShowActivity?.start_time

  const newPricePoint = () => {
    addOnForFormChanged({
      ...addOnForForm,
      price_points: [
        ...addOnForForm.price_points,
        {
          id: Date.now() + Math.random(),
          newRecord: true,
          starts_at: "",
          price_two_decimals: ""
        }
      ]
    })
  }

  useEffect(() => {
    debouncedDetermineFinalCosts = _.debounce((addOn) => {
      determineFinalCosts(addOn);
    }, 500);
  }, []);

  useEffect(() => {
    if (isAddOnFormOpen) {
      determineFinalCosts(addOnForForm);
    }
  }, [isAddOnFormOpen]);

  useEffect(() => {
    return () => {
      if (addOnForForm.image_preview_url) {
        URL.revokeObjectURL(addOnForForm.image_preview_url);
      }
    };
  }, [addOnForForm.image_preview_url]);

  const addOnArchivedSelected = !!addOnSeatingChartEvent?.seating_chart_id
    && !addOnSeatingCharts.some((sc) => sc.id === addOnSeatingChartEvent.seating_chart_id);

  const addOnSeatingChartOptions = [
    ...(addOnArchivedSelected ? [{
      value: addOnSeatingChartEvent.seating_chart_id,
      label: `Archived: ${addOnSeatingChartEvent?.seating_chart_name || `Chart #${addOnSeatingChartEvent.seating_chart_id}`}`,
      disabled: true
    }] : []),
    ...addOnSeatingCharts.map((seatingChart) => ({ value: seatingChart.id, label: seatingChart.name }))
  ];

  return (
    <div>
      {
        canEditSeatingChart(addOnEventChartClone) &&

        <EditSeatingChartDesigner
          show={showDesigner}
          onClose={() => setShowDesigner(false)}
          seatingChart={addOnEventChartClone}
          onChartSynced={reloadAddOns}
          readOnlyName={true}
        />
      }
      {
        addOnEventChartClone && canEditSeatingChart(addOnEventChartClone) &&

        <SaveAsTemplateModal
          open={showSaveTemplate}
          onClose={() => setShowSaveTemplate(false)}
          seatingChart={addOnEventChartClone}
          context="add_on"
          csrfToken={csrfToken}
        />
      }
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-end justify-content-md-end"
            style={{
              "marginBottom": "20px",
              "paddingRight": "15px"
            }}>
          <Popup arrow={false}
                offsetY={5}
                position="bottom right"
                contentStyle={addOnOptionsPopupContentStyle}
                onOpen={
                  (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }
                }
                trigger={
                  <span style={{"display": "inline-flex"}}>
                    <Button variant="secondary" size="sm" trailingIcon={Settings01}>
                      Options
                    </Button>
                  </span>
                } >
            {close => (
              <div className="text-left" style={{"display": "flex", "flexDirection": "column", "gap": "8px"}}>
                <div className="d-flex align-items-center justify-content-between">
                  <Checkbox
                    id="confirm-has-add-ons-intro"
                    size="sm"
                    label="Add-ons intro"
                    checked={!!confirm.has_add_ons_intro}
                    onChange={
                      (e) => {
                        var updated = Object.assign({}, confirm, {
                          has_add_ons_intro: e.target.checked
                        });

                        updateConfirm(updated);
                        autoSaveConfirm(csrfToken, team, updated);
                      }
                    }
                  />
                  <Button
                    variant="tertiary"
                    size="sm"
                    icon={Edit01}
                    aria-label="Edit add-ons intro"
                    disabled={!confirm.has_add_ons_intro}
                    onClick={() => {
                      if(confirm.has_add_ons_intro){
                        isEditingAddOnsIntroChanged(true);
                      }
                    }}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <Checkbox
                    id="confirm-has-add-ons-alert-message"
                    size="sm"
                    label="Alert Message"
                    checked={!!confirm.has_add_ons_alert_message}
                    onChange={
                      (e) => {
                        var updated = Object.assign({}, confirm, {
                          has_add_ons_alert_message: e.target.checked
                        });

                        updateConfirm(updated);
                        autoSaveConfirm(csrfToken, team, updated);
                      }
                    }
                  />
                  <Button
                    variant="tertiary"
                    size="sm"
                    icon={Edit01}
                    aria-label="Edit alert message"
                    disabled={!confirm.has_add_ons_alert_message}
                    onClick={() => {
                      if(confirm.has_add_ons_alert_message){
                        isEditingAddOnsAlertMessageChanged(true);
                      }
                    }}
                  />
                </div>
              </div>
            )}
          </Popup>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md">
          <p className="mb-0"
              style={{"fontSize": "16px"}}>
            <strong>Standard</strong>
          </p>
          <p className="small mb-1" style={shellHelpTextStyle}>
            Sell additional items like ticket upgrades, parking, and merch packages.
          </p>
        </div>
        {standardAddOns.length > 0 ? (
          <div className="col-12 col-md-auto">
            <div className="d-flex justify-content-end flex-wrap" style={{ gap: 8 }}>
              <AddOnPresetPicker teamId={team.id} onPick={(presetId) => fetchNewAddOn(csrfToken, team, confirm, null, presetId)} />
              <Button
                variant="secondary"
                size="sm"
                onClick={() => fetchNewAddOn(csrfToken, team, confirm)}
              >
                Add Add-on
              </Button>
            </div>
          </div>
        ) : null}
      </div>
      <div className='row'>
        <div className='col-12'>
          {standardAddOns.length === 0 ? (
            <div className="row">
              <div className="col-12"
                  style={{"marginTop": "12px"}}>
                <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                  <Button
                    variant="primary"
                    onClick={() => fetchNewAddOn(csrfToken, team, confirm)}
                  >
                    Create Add-on
                  </Button>
                  <AddOnPresetPicker teamId={team.id} size="md" onPick={(presetId) => fetchNewAddOn(csrfToken, team, confirm, null, presetId)} />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <AddOnsTable csrfToken={csrfToken}
                              team={team}
                              currentUser={currentUser}
                              confirm={confirm}
                              addOns={standardAddOns}
                              fetchNewAddOn={fetchNewAddOn}
                              fetchAddOnToEdit={fetchAddOnToEdit}
                              deleteAddOn={deleteAddOn}
                              updateAddOn={updateAddOn}
                              canChangeAddOnSeatingChart={false}
                              setDuplicatingAddOnId={setDuplicatingAddOnId}
                              isSharingInventory={isSharingInventory}
                              addOnDragged={addOnDragged} />
              </div>
            </div>
          )}
        </div>
      </div>
      {addOnSeatingCharts.length > 0 ? (
        <>
          <div className="row">
            <div className="col-12">
              <hr style={shellDividerStyle} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md">
              <p className="mb-0"
                  style={{"fontSize": "16px"}}>
                <strong>Seated</strong>
              </p>
              <p className="small mb-1" style={shellHelpTextStyle}>
                Create a seated add-on to allow fans to purchase an upgraded seat.
              </p>
            </div>
            {addOnSeatingChartEvent?.seating_chart_id && addOnSeatingCharts.length > 0 ? (
              <div className="col-12 col-md-auto d-flex justify-content-end align-items-center"
                    style={{
                      "marginBottom": "13px",
                      "paddingRight": "15px",
                      "gap": "8px"
                    }}>
                <SetlistSelect
                  size="sm"
                  width={200}
                  aria-label="Seating chart"
                  disabled={!canChangeAddOnSeatingChart(confirm, isLoadingDefaultAddOns)}
                  options={addOnSeatingChartOptions}
                  value={addOnSeatingChartEvent.seating_chart_id}
                  onChange={(seatingChartId) => {
                    if (seatingChartId === addOnSeatingChartEvent.seating_chart_id) return;
                    onSelectSeatingChart({ id: String(seatingChartId) });
                  }}
                />
                {
                  canEditSeatingChart(addOnEventChartClone) ? (
                    <Menu
                      placement="bottom-end"
                      trigger={
                        <Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Seating chart actions" />
                      }
                      items={[
                        { label: "Edit Seating Chart", icon: Edit01, onClick: () => setShowDesigner(true) },
                        { label: "Save as venue template", icon: Copy01, onClick: () => setShowSaveTemplate(true) }
                      ]}
                    />
                  ) : (
                    <Tooltip title={reasonWeCannotEditSeatingChart(addOnEventChartClone)}>
                      <span tabIndex={0}>
                        <Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Seating chart actions" disabled />
                      </span>
                    </Tooltip>
                  )
                }
              </div>
            ) : null}
          </div>
          {isLoadingDefaultAddOns ? (
            <div className="form-row mt-3">
              <div className="col-12 text-center">
                <Spinner size="lg" />
              </div>
            </div>
            ) : addOnSeatingCharts.length > 0 && !addOnSeatingChartEvent?.seating_chart_id ? (
            <div className="form-row" style={{"marginTop": "14px"}}>
              {addOnSeatingCharts.map((seatingChart, index) =>
                <SeatingChartCard
                  key={index}
                  seatingChart={seatingChart}
                  onSelectChart={onSelectSeatingChart}
                  csrfToken={csrfToken}
                  isAddOn={true}
                />
              )}
            </div>
          ) : (
            <AddOnsTable csrfToken={csrfToken}
                            team={team}
                            currentUser={currentUser}
                            confirm={confirm}
                            addOns={seatedAddOns.filter((ao) => ao.seating_chart_event_id === confirm.add_on_seating_chart_event_id)}
                            fetchNewAddOn={fetchNewAddOn}
                            fetchAddOnToEdit={fetchAddOnToEdit}
                            deleteAddOn={deleteAddOn}
                            updateAddOn={updateAddOn}
                            destroySeatingChartEvent={destroySeatingChartEvent}
                            canChangeAddOnSeatingChart={canChangeAddOnSeatingChart(confirm, isLoadingDefaultAddOns)}
                            setDuplicatingAddOnId={setDuplicatingAddOnId}
                            isSharingInventory={isSharingInventory}
                            addOnDragged={addOnDragged} />
          )}
        </>
      ) : null}
      {addOnSeatingCharts.length > 0 ? (
        <div className="row">
          <div className="col-12">
            <hr style={shellDividerStyle} />
          </div>
          <div className="col-12 col-md">
            <p className="mb-0" style={{"fontSize": "16px"}}>
              <strong>Seat maps for each day</strong>
            </p>
            <p className="small mb-1" style={shellHelpTextStyle}>
              For shows that run more than one day. Fans pick a seat for each day in the festival widget.
            </p>
          </div>
          <div className="col-12 col-md-auto d-flex justify-content-end align-items-center" style={{"marginBottom": "13px", "paddingRight": "15px"}}>
            <Button variant="secondary" size="sm" icon={Plus} onClick={() => setDayMapModal({})}>
              Add a seat map for a day
            </Button>
          </div>
        </div>
      ) : null}
      {seatingChartEvents.map((seatingChartEvent, index) => (
        <div key={index}>
          <div className="row">
            <div className="col-12">
              <hr style={shellDividerStyle} />
            </div>
            <div className="col-12 col-md">
              <p className="mb-0"
                  style={{"fontSize": "16px"}}>
                <strong>{seatingChartEvent.name}</strong>
              </p>
              <p className="small mb-1" style={shellHelpTextStyle}>
                This seating chart can only be used with the festival widget.
              </p>
            </div>
            <div className="col-12 col-md-auto d-flex justify-content-end align-items-center" style={{"marginBottom": "13px", "paddingRight": "15px"}}>
              <Menu
                placement="bottom-end"
                trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label={`${seatingChartEvent.name} actions`} />}
                items={[
                  { label: "Rename", icon: Edit01, onClick: () => setDayMapModal({ seatingChartEvent }) },
                  { label: "Remove", icon: XClose, onClick: () => setDayMapToRemove(seatingChartEvent), destructive: true, disabled: !canChangeAddOnSeatingChart(confirm, isLoadingDefaultAddOns) }
                ]}
              />
            </div>
          </div>
          <AddOnsTable csrfToken={csrfToken}
                          team={team}
                          currentUser={currentUser}
                          confirm={confirm}
                          addOns={seatedAddOns.filter((ao) => ao.seating_chart_event_id === seatingChartEvent.id)}
                          fetchNewAddOn={fetchNewAddOn}
                          fetchAddOnToEdit={fetchAddOnToEdit}
                          deleteAddOn={deleteAddOn}
                          updateAddOn={updateAddOn}
                          canChangeAddOnSeatingChart={canChangeAddOnSeatingChart(confirm, isLoadingDefaultAddOns)}
                          setDuplicatingAddOnId={setDuplicatingAddOnId}
                          seatingChartEvent={seatingChartEvent}
                          isSharingInventory={isSharingInventory}
                          addOnDragged={addOnDragged} />
        </div>
      ))}
      {dayMapModal ? (
        <DaySeatMapModal
          seatingCharts={addOnSeatingCharts}
          seatingChartEvent={dayMapModal.seatingChartEvent || null}
          showStart={confirm.start_time}
          showEnd={confirm.end_time}
          saving={isSavingDayMap}
          onSave={saveDayMap}
          onClose={() => setDayMapModal(null)}
        />
      ) : null}
      {dayMapToRemove ? (
        <Modal
          open
          type="warning"
          onClose={() => setDayMapToRemove(null)}
          title={`Remove ${dayMapToRemove.name}?`}
          description="Fans won't be able to pick seats for this day any more, and its seated add-ons are removed too."
          footer={
            <>
              <Button variant="secondary" onClick={() => setDayMapToRemove(null)}>Cancel</Button>
              <Button variant="primary" disabled={isSavingDayMap} onClick={removeDayMap}>Remove</Button>
            </>
          }
        />
      ) : null}
      {team.can_access_ticketing_setup_redesign ? (
        isAddOnFormOpen ? (
          <AddOnDrawer
            addOnForForm={addOnForForm}
            addOns={addOns}
            confirm={confirm}
            team={team}
            showActivities={showActivities}
            ticketTypes={ticketTypes}
            manualTaxes={manualTaxes}
            manualTaxShouldBeChecked={manualTaxShouldBeChecked}
            canSave={Boolean(canSubmitForm(addOnForForm))}
            closeOnEsc={pricePointToRemove === null}
            onChange={addOnForFormChanged}
            onRecalculate={(addOn) => debouncedDetermineFinalCosts(addOn)}
            onImageSelected={handleAddOnImageSelected}
            onImageRemove={handleAddOnImageRemove}
            onRemovePricePoint={setPricePointToRemove}
            onSave={() => (
              addOnForForm.id
                ? updateAddOn(csrfToken, team, addOnForForm)
                : createAddOn(csrfToken, team, confirm, addOnForForm)
            )}
            onClose={closeAddOnForm}
          />
        ) : null
      ) : (
      <Drawer
        open={isAddOnFormOpen}
        backdrop
        width={600}
        data-lift-conductor-orb={isAddOnFormOpen || undefined}
        title={addOnForForm.id ? "Edit Add-on" : "Create Add-on"}
        closeOnEsc={pricePointToRemove === null}
        onClose={() => closeAddOnForm()}
        footer={
          <>
            <Button
              variant="secondary"
              onClick={() => closeAddOnForm()}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              form={ADD_ON_DRAWER_FORM_ID}
              disabled={!canSubmitForm(addOnForForm)}
            >
              Save
            </Button>
          </>
        }
      >
          <form id={ADD_ON_DRAWER_FORM_ID}
                className="add-on-drawer"
                onSubmit={
                  (e) => {
                    e.preventDefault();

                    if(!canSubmitForm(addOnForForm)){
                      return false;
                    }

                    if(addOnForForm.id){
                      updateAddOn(csrfToken, team, addOnForForm);
                    } else {
                      createAddOn(csrfToken, team, confirm, addOnForForm);
                    }
                  }
                }>
                <Checkbox
                  id="add-on-require-ticket-type"
                  label="This item is only available with purchase of a ticket"
                  checked={addOnForForm.require_ticket_type || false}
                  onChange={
                    (e) => {
                      var updated = Object.assign({}, addOnForForm, {
                        require_ticket_type: e.target.checked,
                        ticket_type_ids: []
                      });

                      addOnForFormChanged(updated);
                    }
                  }
                />
                {addOnForForm.require_ticket_type ? (
                  <>
                    <div className="ticket-drawer-field">
                      <Checkbox
                        id="add-on-limit-quantity-to-admission-count"
                        label="Limit quantity to admission count"
                        checked={addOnForForm.limit_quantity_to_admission_count !== false}
                        onChange={
                          (e) => {
                            var updated = Object.assign({}, addOnForForm, {
                              limit_quantity_to_admission_count: e.target.checked
                            });

                            addOnForFormChanged(updated);
                          }
                        }
                      />
                      <p className="ticket-drawer-muted-text">
                        When enabled, the add-on quantity is capped at the number of admission tickets in the buyer's order. Disable for table or group products where one admission should be able to buy multiple.
                      </p>
                    </div>
                    <Checkbox
                      id="add-on-disable-require-ticket-type-with-direct-link"
                      label="Disable ticket requirement with direct add-on link"
                      checked={addOnForForm.disable_require_ticket_type_with_direct_link || false}
                      onChange={
                        (e) => {
                          var updated = Object.assign({}, addOnForForm, {
                            disable_require_ticket_type_with_direct_link: e.target.checked
                          });

                          addOnForFormChanged(updated);
                        }
                      }
                    />
                    <SetlistSelect
                      id="add-on-ticket-type-ids"
                      label="Required Ticket(s)"
                      placeholder="Select"
                      multiple
                      searchable
                      clearable
                      options={
                        ticketTypes
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((tt) => ({value: tt.id, label: tt.name}))
                      }
                      value={
                        ticketTypes
                          .filter((tt) => {
                            const ticketTypeIds = addOnForForm.ticket_type_ids || [];
                            return ticketTypeIds.some(id => Number(id) === Number(tt.id));
                          })
                          .map((tt) => tt.id)
                      }
                      onChange={
                        (ticketTypeIds) => {
                          var updated = Object.assign({}, addOnForForm, {ticket_type_ids: ticketTypeIds || []});

                          addOnForFormChanged(updated);
                        }
                      }
                    />
                  </>
                ) : null}
                {(!addOnIsSeated(addOnForForm) && requiredAddOnOptions(addOns, addOnForForm).length > 0) || addOnForForm.require_add_on ? (
                  <>
                  <Checkbox
                    id="add-on-require-add-on"
                    label="This item is only available with purchase of an add-on"
                    checked={addOnForForm.require_add_on || false}
                    onChange={
                      (e) => {
                        var updated = Object.assign({}, addOnForForm, {
                          require_add_on: e.target.checked,
                          required_add_on_ids: []
                        });

                        addOnForFormChanged(updated);
                      }
                    }
                  />
                  {addOnForForm.require_add_on ? (
                    <SetlistSelect
                      id="add-on-required-add-on-ids"
                      label="Required Add-on(s)"
                      placeholder="Select"
                      multiple
                      searchable
                      clearable
                      options={requiredAddOnOptions(addOns, addOnForForm)}
                      value={addOnForForm.required_add_on_ids || []}
                      onChange={
                        (addOnIds) => {
                          var updated = Object.assign({}, addOnForForm, {required_add_on_ids: addOnIds || []});

                          addOnForFormChanged(updated);
                        }
                      }
                    />
                  ) : null}
                  </>
                ) : null}
                <Checkbox
                  id="add-on-transferable"
                  label="Fans can transfer this"
                  checked={addOnForForm.transferable ?? true}
                  onChange={
                    (e) => {
                      addOnForFormChanged(Object.assign({}, addOnForForm, {transferable: e.target.checked ? null : false}));
                    }
                  }
                />
                <div className="ticket-drawer-field">
                  <Checkbox
                    id="add-on-resellable"
                    label="Fans can resell this"
                    checked={(addOnForForm.transferable ?? false) && !(addOnIsSeated(addOnForForm) && addOnForForm.accessible_seating)}
                    disabled={Boolean(addOnIsSeated(addOnForForm) && addOnForForm.accessible_seating)}
                    onChange={
                      (e) => {
                        addOnForFormChanged(Object.assign({}, addOnForForm, {transferable: e.target.checked ? true : null}));
                      }
                    }
                    aria-describedby={addOnIsSeated(addOnForForm) ? "add-on-resellable-seat-note" : undefined}
                  />
                  {addOnIsSeated(addOnForForm) && addOnForForm.accessible_seating ? (
                    <p id="add-on-resellable-seat-note" className="ticket-drawer-muted-text">
                      Accessible and companion seats can never be resold.
                    </p>
                  ) : addOnIsSeated(addOnForForm) ? (
                    <p id="add-on-resellable-seat-note" className="ticket-drawer-muted-text">
                      {(addOnForForm.transferable ?? false)
                        ? "This seat is sold separately from its ticket. A resold ticket won't include it."
                        : "This seat still goes with its ticket when the ticket is resold."}
                    </p>
                  ) : null}
                </div>
                {addOnIsSeated(addOnForForm) ? (
                <SetlistSelect
                  id="add-on-accessible-seating"
                  label="Accessible seating"
                  hint="Companion seats are sold alongside an accessible seat. Accessible and companion seats can't be resold."
                  options={ACCESSIBLE_SEATING_OPTIONS}
                  value={addOnForForm.accessible_seating || ''}
                  onChange={(accessibleSeating) => addOnForFormChanged({ ...addOnForForm, accessible_seating: accessibleSeating })}
                />
                ) : null}
                <TextInput
                  id="ticket-type-name"
                  label={<>Name<span className="ticket-drawer-required">&nbsp;*</span></>}
                  value={addOnForForm.base_name || ""}
                  onChange={
                    (e) => {
                      var updated = {
                        ...addOnForForm,
                        base_name: e.target.value
                      }

                      addOnForFormChanged(updated);
                    }
                  }
                />
                <TextInput
                  as={MaskedInput}
                  id="add-on-available"
                  label="Total Quantity"
                  mask={createNumberMask({
                    prefix: "",
                    decimalLimit: 0
                  })}
                  disabled={addOnIsSeated(addOnForForm)}
                  onChange={
                    (e) => {
                      var updated = Object.assign({}, addOnForForm, {available: e.target.value});
                      addOnForFormChanged(updated);
                    }
                  }
                  value={addOnForForm.available || ""}
                />
                <div className="ticket-drawer-field">
                  <TextInput
                    as={CurrencyInput}
                    id="add-on-price"
                    label="Price"
                    leadingText="$"
                    maskOptions={{
                      prefix: "",
                      integerLimit: null
                    }}
                    value={addOnForForm.base_price_two_decimals || ""}
                    onChange={
                      (e) => {
                        var updated = Object.assign({}, addOnForForm, {base_price_two_decimals: e.target.value});

                        addOnForFormChanged(updated);
                        debouncedDetermineFinalCosts(updated);
                      }
                    }
                  />
                  <PriceBreakoutAccordion item={addOnForForm} />
                </div>
                <DynamicPricingSection
                  ticketTypeForForm={addOnForForm}
                  onTicketTypeChange={addOnForFormChanged}
                  team={team}
                />
                <Checkbox
                  id="add-on-round-up"
                  label="Round Up: Increase the organizer fee to round the final cost to the nearest dollar"
                  checked={addOnForForm.round_up || false}
                  onChange={
                    (e) => {
                      var updated = Object.assign({}, addOnForForm, {
                        round_up: e.target.checked,
                      });

                      addOnForFormChanged(updated);
                      debouncedDetermineFinalCosts(updated);
                    }
                  }
                />
                <Checkbox
                  id="ticket-type-absorb-fees"
                  label="Absorb Fees: Ticketing fees are deducted from your ticket revenue"
                  checked={addOnForForm.absorb_fees || false}
                  onChange={
                    (e) => {
                      var updated = Object.assign({}, addOnForForm, {
                        absorb_fees: e.target.checked
                      });

                      addOnForFormChanged(updated);
                      debouncedDetermineFinalCosts(updated);
                    }
                  }
                />
                {!addOnIsSeated(addOnForForm) || isSharingInventory(addOns, addOnForForm) ? (
                  <TextInput
                    as={DebounceInput}
                    element="textarea"
                    multiline
                    rows={3}
                    resize="none"
                    id="add-on-description"
                    label="Description"
                    placeholder="Tell attendees more about this add-on..."
                    value={addOnForForm.description || ""}
                    onChange={
                      (e) => {
                        var updated = Object.assign({}, addOnForForm, {description: e.target.value});
                        addOnForFormChanged(updated);
                      }
                    }
                  />
                ) : null}
                <hr className="add-on-drawer-divider" />
                <TextInput
                  as={DebounceInput}
                  element="textarea"
                  multiline
                  rows={3}
                  resize="none"
                  id="add-on-confirmation-details"
                  label="Details for confirmation email"
                  placeholder="Tell attendees more about this add-on..."
                  value={addOnForForm.confirmation_details || ""}
                  onChange={
                    (e) => {
                      var updated = Object.assign({}, addOnForForm, {confirmation_details: e.target.value});
                      addOnForFormChanged(updated);
                    }
                  }
                />
                <div className="ticket-drawer-field">
                  <div className="add-on-drawer-image-header">
                    <div>
                      <p className="ticket-drawer-block-title add-on-drawer-image-title">
                        Add Image
                      </p>
                      <p className="ticket-drawer-muted-text">
                        Add an image to your add-on
                      </p>
                    </div>
                    <Toggle
                      id="add-on-has-image"
                      aria-label="Add Image"
                      checked={addOnForForm.has_image || false}
                      onChange={e => {
                        if (e.target.checked) {
                          addOnForFormChanged({
                            ...addOnForForm,
                            has_image: true
                          });
                        } else {
                          handleAddOnImageRemove();
                        }
                      }}
                    />
                  </div>
                  {addOnForForm.has_image && (
                    <ImageUpload
                      imageUrl={addOnForForm.image_preview_url || addOnForForm.image_url}
                      onUpload={handleAddOnImageSelected}
                      onDelete={handleAddOnImageRemove}
                      selectedFile={addOnForForm.image_file_info}
                      placeholder={{
                        title: 'Click to upload',
                        subtitle: 'or drag and drop',
                        formats: 'SVG, PNG, JPG or GIF (max. 800x400px)'
                      }}
                    />
                  )}
                </div>
                <hr className="add-on-drawer-divider" />
                <div>
                  <p className="ticket-drawer-block-title">Add-ons Per Order</p>
                  <div className="ticket-drawer-field-row">
                    <div className="ticket-drawer-field">
                      <TextInput
                        as={MaskedInput}
                        id="add-on-minimum-per-order"
                        label="Minimum"
                        error={minPerOrderMoreThanMax(addOnForForm) || undefined}
                        mask={createNumberMask({
                          prefix: "",
                          decimalLimit: 0
                        })}
                        disabled={addOnIsSeated(addOnForForm)}
                        onChange={
                          (e) => {
                            var updated = Object.assign({}, addOnForForm, {minimum_per_order: e.target.value});
                            addOnForFormChanged(updated);
                          }
                        }
                        value={addOnForForm.minimum_per_order || ""}
                      />
                    </div>
                    <div className="ticket-drawer-field">
                      <TextInput
                        as={MaskedInput}
                        id="add-on-maximum-per-order"
                        label="Maximum"
                        error={minPerOrderMoreThanMax(addOnForForm) || undefined}
                        mask={createNumberMask({
                          prefix: "",
                          decimalLimit: 0
                        })}
                        onChange={
                          (e) => {
                            var updated = Object.assign({}, addOnForForm, {maximum_per_order: e.target.value});
                            addOnForFormChanged(updated);
                          }
                        }
                        value={addOnForForm.maximum_per_order || ""}
                      />
                    </div>
                  </div>
                </div>
                <SetlistSelect
                  id="add-on-sales-channel"
                  label="Sales Channel"
                  options={SALES_CHANNEL_OPTIONS}
                  value={addOnForForm.sales_channel || SALES_CHANNEL_OPTIONS[0].value}
                  onChange={(salesChannel) => {
                    addOnForFormChanged(Object.assign({}, addOnForForm, {sales_channel: salesChannel}));
                  }}
                />
                <SetlistSelect
                  id="add-on-availability"
                  label="When are add-ons available?"
                  options={AVAILABILITY_OPTIONS}
                  value={addOnForForm.availability || AVAILABILITY_OPTIONS[0].value}
                  onChange={
                    (availability) => {
                      var params = {availability: availability};

                      var updated = Object.assign({}, addOnForForm, params);
                      addOnForFormChanged(updated);
                    }
                  }
                />
                <div className="ticket-drawer-field-row">
                  <div className="ticket-drawer-field">
                    {useDateAndTime ? (
                      <div>
                        <label htmlFor="add-on-start-date" className="ticket-drawer-field-label">
                          <RequiredLabel>Start Date</RequiredLabel>
                        </label>
                        <Flatpickr
                          id="add-on-start-date"
                          options={{
                            dateFormat: "M j, Y at h:iK",
                            enableTime: true,
                          }}
                          placeholder={"Select date"}
                          className={"form-control ticketing-date-picker form-control-flatpickr"}
                          style={{fontSize: "14px"}}
                          value={addOnForForm.start_time}
                          onClose={dates => {
                            var startTime = parseDateTime(dates[0]);
                            var endTime   = parseDateTime(addOnForForm.end_time);

                            var attrs = {
                              start_time: startTime
                            };

                            if(endTime && endTime < startTime){
                              endTime = "";
                              attrs = Object.assign({}, attrs, {
                                end_time: endTime
                              });
                            };

                            var updated = Object.assign({}, addOnForForm, attrs);
                            addOnForFormChanged(updated);
                          }}
                        />
                      </div>
                    ) : (
                      <SetlistSelect
                        id="add-on-start-show-activity"
                        label={<RequiredLabel>Start Show Detail</RequiredLabel>}
                        placeholder="Select a show detail"
                        options={showActivityOptions}
                        value={startShowActivity ? startShowActivity.id : null}
                        onChange={showActivityId => {
                          addOnForFormChanged({
                            ...addOnForForm,
                            start_show_activity_id: showActivityId
                          });
                        }}
                      />
                    )}
                  </div>
                  {visiblePricePoints(addOnForForm?.price_points).length > 0 ? (
                    <div className="ticket-drawer-field add-on-drawer-price-point-price">
                      <TextInput
                        as={CurrencyInput}
                        id="add-on-price-reference"
                        label={<LabelWithInfo tip="Based on the price field above">Price</LabelWithInfo>}
                        leadingText="$"
                        disabled
                        maskOptions={{prefix: ""}}
                        value={addOnForForm.base_price_two_decimals || ""}
                        hint={addOnForForm.final_cost ? `Final: ${formatter.format(parseFloat(addOnForForm.final_cost))}` : undefined}
                      />
                    </div>
                  ) : null}
                </div>
                {visiblePricePoints(addOnForForm?.price_points).map((price_point, index) => {
                  return (
                    <div key={price_point.id} className="add-on-drawer-price-point">
                      <div className="add-on-drawer-price-point-header">
                        <Badge color="brand" size="sm">
                          Price Change {index + 1}
                        </Badge>
                        <Button
                          variant="tertiary"
                          size="sm"
                          icon={XClose}
                          aria-label={`Remove price change ${index + 1}`}
                          onClick={e => {
                            e.preventDefault();

                            setPricePointToRemove(price_point);
                          }}
                        />
                      </div>
                      <div className="add-on-drawer-price-point-fields">
                        <div className="ticket-drawer-field">
                          <TextInput
                            id={`price-point-${price_point.id}-name`}
                            label="Description"
                            value={price_point.name || ""}
                            placeholder="Advanced, Day of Show, etc..."
                            hint={`Displays as: ${addOnForForm.base_name}${(price_point.name?.length || 0) > 0 ? ` - ${price_point.name}` : ""}`}
                            onChange={e => {
                              const updated = {
                                ...price_point,
                                name: e.target.value
                              }
                              addOnForFormChanged({
                                ...addOnForForm,
                                price_points: addOnForForm.price_points.map(pp => pp.id === updated.id ? updated : pp)
                              });
                            }}
                          />
                        </div>
                        <div className="ticket-drawer-field">
                          <div>
                            <label htmlFor={`price-point-${price_point.id}-start-date`} className="ticket-drawer-field-label">
                              <RequiredLabel>Date</RequiredLabel>
                            </label>
                            <Flatpickr
                              id={`price-point-${price_point.id}-start-date`}
                              options={{
                                dateFormat: "M j, Y, h:i K",
                                enableTime: true,
                                minDate: parseDateTime(pricePointsMinDate || null),
                                maxDate: parseDateTime(pricePointsMaxDate || null)
                              }}
                              placeholder={"Select date"}
                              className={"form-control ticketing-date-picker form-control-flatpickr"}
                              style={{fontSize: "14px"}}
                              value={parseDateTime(price_point.starts_at)}
                              onClose={dates => {
                                const updated = {
                                  ...price_point,
                                  starts_at: parseDateTime(dates[0])
                                }

                                addOnForFormChanged({
                                  ...addOnForForm,
                                  price_points: addOnForForm.price_points.map(pp => pp.id === updated.id ? updated : pp)
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="ticket-drawer-field add-on-drawer-price-point-price">
                          <TextInput
                            as={CurrencyInput}
                            id={`price-point-${price_point.id}-price`}
                            label={<RequiredLabel>Price</RequiredLabel>}
                            leadingText="$"
                            maskOptions={{prefix: ""}}
                            value={price_point.price_two_decimals || ""}
                            placeholder="0.00"
                            onChange={e => {
                              const updatedPricePoint = {
                                ...price_point,
                                price_two_decimals: e.target.value
                              };

                              const updated = {
                                ...addOnForForm,
                                price_points: addOnForForm.price_points.map(pp => pp.id === updatedPricePoint.id ? updatedPricePoint : pp)
                              }

                              addOnForFormChanged(updated);
                              debouncedDetermineFinalCosts(updated);
                            }}
                          />
                        </div>
                      </div>
                      <PriceBreakoutAccordion item={price_point} accordionId={`PricePoint${price_point.id}`} />
                    </div>
                  )
                })}
                <div>
                  <Button
                    variant="link-color"
                    icon={Plus}
                    onClick={() => newPricePoint()}
                  >
                    Add a price change
                  </Button>
                </div>
                {useDateAndTime ? (
                  <div>
                    <label htmlFor="add-on-end-date" className="ticket-drawer-field-label">
                      <RequiredLabel>End Date</RequiredLabel>
                    </label>
                    <Flatpickr
                      id="add-on-end-date"
                      options={{
                        dateFormat: "M j, Y at h:iK",
                        enableTime: true,
                        minDate: addOnForForm.start_time,
                      }}
                      disabled={!addOnForForm.start_time}
                      placeholder={"Select date"}
                      className={"form-control ticketing-date-picker form-control-flatpickr " + (!addOnForForm.start_time ? "form-control-disabled" : "")}
                      style={{fontSize: "14px"}}
                      value={addOnForForm.end_time}
                      onClose={dates => {
                        var startTime = parseDateTime(addOnForForm.start_time);
                        var endTime   = parseDateTime(dates[0]);

                        var attrs = {
                          end_time: endTime
                        };

                        if(endTime && startTime && endTime < startTime){
                          endTime = "";
                          attrs = Object.assign({}, attrs, {
                            end_time: endTime
                          });
                        };

                        var updated = Object.assign({}, addOnForForm, attrs);
                        addOnForFormChanged(updated);
                      }}
                    />
                  </div>
                ) : (
                  <SetlistSelect
                    id="add-on-end-show-activity"
                    label={<RequiredLabel>End Show Detail</RequiredLabel>}
                    placeholder="Select a show detail"
                    options={showActivityOptions}
                    value={endShowActivity ? endShowActivity.id : null}
                    onChange={showActivityId => {
                      addOnForFormChanged({
                        ...addOnForForm,
                        end_show_activity_id: showActivityId
                      });
                    }}
                  />
                )}
                <Toggle
                  id="ticket-type-timed-entry"
                  label="Timed Entry"
                  checked={addOnForForm.timed_entry || false}
                  onChange={e => {
                    addOnForFormChanged({
                      ...addOnForForm,
                      timed_entry: e.target.checked
                    });
                  }}
                />
                {addOnForForm.timed_entry ? (
                  <>
                    <SetlistSelect
                      id="ticket-type-timed-entry-availability"
                      label="When can tickets be scanned?"
                      options={AVAILABILITY_OPTIONS}
                      value={addOnForForm.timed_entry_availability || AVAILABILITY_OPTIONS[0].value}
                      onChange={timedEntryAvailability => {
                        addOnForFormChanged({
                          ...addOnForForm,
                          timed_entry_availability: timedEntryAvailability
                        });
                      }}
                    />
                    {addOnForForm.timed_entry_availability === "Date & Time" ? (
                      <>
                        <div>
                          <label htmlFor="add-on-timed-entry-start-date" className="ticket-drawer-field-label">
                            <RequiredLabel>Scan Start Time</RequiredLabel>
                          </label>
                          <Flatpickr
                            id="add-on-timed-entry-start-date"
                            options={{
                              dateFormat: "M j, Y at h:iK",
                              enableTime: true,
                            }}
                            placeholder={"Select date and time"}
                            className={"form-control ticketing-date-picker form-control-flatpickr"}
                            style={{fontSize: "14px"}}
                            value={addOnForForm.timed_entry_start}
                            onClose={dates => {
                              var startTime = parseDateTime(dates[0]);
                              var endTime   = parseDateTime(addOnForForm.timed_entry_end);

                              var attrs = {
                                timed_entry_start: startTime,
                              };

                              if(endTime && endTime < startTime){
                                endTime = "";
                                attrs = {
                                  ...attrs,
                                  timed_entry_end: endTime
                                };
                              }

                              addOnForFormChanged({
                                ...addOnForForm,
                                ...attrs
                              });
                            }}
                          />
                        </div>
                        <div>
                          <label htmlFor="add-on-timed-entry-end-date" className="ticket-drawer-field-label">
                            <RequiredLabel>Scan End Time</RequiredLabel>
                          </label>
                          <Flatpickr
                            id="add-on-timed-entry-end-date"
                            options={{
                              dateFormat: "M j, Y at h:iK",
                              enableTime: true,
                            }}
                            placeholder={"Select date and time"}
                            className={"form-control ticketing-date-picker form-control-flatpickr"}
                            style={{fontSize: "14px"}}
                            value={addOnForForm.timed_entry_end}
                            onClose={dates => {
                              addOnForFormChanged({
                                ...addOnForForm,
                                timed_entry_end: parseDateTime(dates[0])
                              });
                            }}
                          />
                        </div>
                      </>
                    ) : addOnForForm.timed_entry_availability == "Based on show details" ? (
                      <>
                        <SetlistSelect
                          id="add-on-timed-entry-start-show-activity"
                          label={<RequiredLabel>Scan Start Show Detail</RequiredLabel>}
                          placeholder="Select a show detail"
                          options={showActivityOptions}
                          value={addOnForForm.timed_entry_start_show_activity_id ?? null}
                          onChange={showActivityId => {
                            addOnForFormChanged({
                              ...addOnForForm,
                              timed_entry_start_show_activity_id: showActivityId
                            });
                          }}
                        />
                        <SetlistSelect
                          id="add-on-timed-entry-end-show-activity"
                          label={<RequiredLabel>Scan Stop Show Detail</RequiredLabel>}
                          placeholder="Select a show detail"
                          options={showActivityOptions}
                          value={addOnForForm.timed_entry_end_show_activity_id ?? null}
                          onChange={showActivityId => {
                            addOnForFormChanged({
                              ...addOnForForm,
                              timed_entry_end_show_activity_id: showActivityId
                            });
                          }}
                        />
                      </>
                    ) : null}
                  </>
                ) : null}
                <hr className="add-on-drawer-divider" />
                <p className="ticket-drawer-block-title">Advanced Settings</p>
                <TextInput
                  as={MaskedInput}
                  id="add-on-check-in-limit"
                  label="How many times can a single ticket be scanned?"
                  hint="Set to 0 for unlimited scans"
                  mask={createNumberMask({ prefix: "", decimalLimit: 0 })}
                  value={addOnForForm.check_in_limit || "0"}
                  onChange={e => {
                    addOnForFormChanged({
                      ...addOnForForm,
                      check_in_limit: e.target.value
                    });
                  }}
                />
                <SetlistSelect
                  id="add-on-check-in-period"
                  label="Check-in Period"
                  hint={'"Daily" resets the check-in count each day at 4 AM venue local time.'}
                  options={CHECK_IN_PERIOD_OPTIONS}
                  value={addOnForForm.check_in_period || "all_time"}
                  onChange={(checkInPeriod) =>
                    addOnForFormChanged({
                      ...addOnForForm,
                      check_in_period: checkInPeriod,
                    })
                  }
                />
                {manualTaxes.length > 0 ? (
                  <div>
                    <p className="ticket-drawer-block-title">Apply Taxes</p>
                    {manualTaxes.sort((a, b) => a.name.localeCompare(b.name)).map((manualTax, index) => (
                      <div key={index} className="ticket-drawer-check-row">
                        <Checkbox
                          id={`manual-tax-${manualTax.id}`}
                          label={`${manualTax.name} (${parseFloat(manualTax.rate)}%)`}
                          checked={
                            manualTaxShouldBeChecked(addOnForForm, manualTax)
                          }
                          onChange={
                            (e) => {
                              var newTaxableItems = [...addOnForForm.taxable_items];
                              var foundIndex = newTaxableItems
                                .map((taxableItem) => taxableItem.manual_tax_id)
                                .indexOf(manualTax.id);

                              if(e.target.checked){
                                if(foundIndex === -1){
                                  newTaxableItems.push(
                                    {
                                      manual_tax_id: manualTax.id,
                                      _destroy: false
                                    }
                                  );
                                } else {
                                  newTaxableItems[foundIndex]._destroy = false;
                                }
                              } else if(foundIndex !== -1){
                                newTaxableItems[foundIndex]._destroy = true;
                              }

                              var updated = Object.assign({}, addOnForForm, {
                                taxable_items: newTaxableItems
                              });
                              addOnForFormChanged(updated);
                            }
                          }
                        />
                      </div>
                    ))}
                  </div>
                ) : null}
                <Toggle
                  id="add-on-hide-qr-code"
                  label={
                    <LabelWithInfo tip="Hide QR codes when you want to sell a ticket that will not need to be scanned for admission or other purposes">
                      Hide QR Code
                    </LabelWithInfo>
                  }
                  checked={addOnForForm.hide_qr_code || false}
                  onChange={e => {
                    addOnForFormChanged({
                      ...addOnForForm,
                      hide_qr_code: e.target.checked
                    });
                  }}
                />
          </form>
      </Drawer>
      )}
      <Modal
        open={isEditingAddOnsIntro}
        width={840}
        closeOnBackdrop={false}
        title="Add-ons Intro"
        onClose={() => isEditingAddOnsIntroChanged(false)}
        footer={
          <>
            <Button variant="secondary" onClick={() => isEditingAddOnsIntroChanged(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={saveAddOnsIntro}>
              Save
            </Button>
          </>
        }
      >
        <div style={{"marginBottom": "16px"}}>
          <AddOnMessageTemplates
            csrfToken={csrfToken}
            team={team}
            kind="intro"
            editorState={addOnsIntroEditorState}
            onEditorStateChange={addOnsIntroEditorStateChanged}
            templates={addOnsIntroTemplates}
            draft={addOnsIntroTemplateDraft}
            draftChanged={addOnMessageTemplateChanged}
            createTemplate={createAddOnMessageTemplate}
            deleteTemplate={deleteAddOnMessageTemplate} />
        </div>
        <RichEditor
          editorState={addOnsIntroEditorState}
          onEditorStateChange={
            (editorState) => {
              addOnsIntroEditorStateChanged(editorState);
            }
          } />
      </Modal>
      <Modal
        open={isEditingAddOnsAlertMessage}
        width={840}
        closeOnBackdrop={false}
        title="Alert Message"
        onClose={() => isEditingAddOnsAlertMessageChanged(false)}
        footer={
          <>
            <Button variant="secondary" onClick={() => isEditingAddOnsAlertMessageChanged(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={saveAddOnsAlertMessage}>
              Save
            </Button>
          </>
        }
      >
        <div style={{"marginBottom": "16px"}}>
          <AddOnMessageTemplates
            csrfToken={csrfToken}
            team={team}
            kind="alert"
            editorState={addOnsAlertMessageEditorState}
            onEditorStateChange={addOnsAlertMessageEditorStateChanged}
            templates={addOnsAlertMessageTemplates}
            draft={addOnsAlertMessageTemplateDraft}
            draftChanged={addOnMessageTemplateChanged}
            createTemplate={createAddOnMessageTemplate}
            deleteTemplate={deleteAddOnMessageTemplate} />
        </div>
        <RichEditor
          editorState={addOnsAlertMessageEditorState}
          onEditorStateChange={
            (editorState) => {
              addOnsAlertMessageEditorStateChanged(editorState);
            }
          } />
      </Modal>
      <Modal
        open={!!duplicatingAddOnId}
        type="error"
        width={492}
        title="Duplicate Add-On?"
        closeOnBackdrop={!isSavingDuplicateAddOn}
        closeOnEsc={!isSavingDuplicateAddOn}
        showClose={!isSavingDuplicateAddOn}
        onClose={() => setDuplicatingAddOnId(false)}
        footer={
          <>
            {!isSavingDuplicateAddOn ? (
              <Button variant="secondary" onClick={() => setDuplicatingAddOnId(false)}>
                Cancel
              </Button>
            ) : null}
            <Button
              variant="destructive"
              disabled={isSavingDuplicateAddOn}
              onClick={() => {
                if(!isSavingDuplicateAddOn){
                  duplicateAddOn(csrfToken, team, duplicatingAddOnId);
                }
              }}
            >
              {isSavingDuplicateAddOn ? (
                <>
                  <Spinner size="sm" color="currentColor" aria-label="Duplicating add-on" />
                  Duplicating...
                </>
              ) : (
                "Yes, duplicate add-on"
              )}
            </Button>
          </>
        }
      >
        <div style={{"fontSize": "14px", "color": "var(--sl-text-secondary)"}}>
          <p style={{"marginBottom": "22px"}}>
            Creating a duplicate of a seated add-on allows you to sell seats from the same inventory at different prices.
          </p>
          <p style={{"marginBottom": "22px"}}>
            This should be done with great care.
          </p>
          <p className="mb-0">
            Are you sure?
          </p>
        </div>
      </Modal>
      <Modal
        open={pricePointToRemove !== null}
        type="error"
        title="Remove price change"
        confirmLabel="Yes, remove price change"
        onClose={() => setPricePointToRemove(null)}
        onConfirm={() => {
          const updated = {
            ...pricePointToRemove,
            _destroy: true
          }

          addOnForFormChanged({
            ...addOnForForm,
            price_points: addOnForForm.price_points.map(pp => pp.id === pricePointToRemove.id ? updated : pp)
          });

          setPricePointToRemove(null);
        }}
      >
        <div style={{"fontSize": "14px", "color": "var(--sl-text-secondary)"}}>
          {pricePointToRemove && !pricePointToRemove.newRecord ? (
            <p style={{"marginBottom": "22px"}}>
              This action will remove the price change, but this change will not be saved until you click the save button below.
            </p>
          ) : null}
          <p className="mb-0">
            Are you sure?
          </p>
        </div>
      </Modal>
    </div>
  );
};

AddOnsTab.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  addOns: PropTypes.array,
  addOnForForm: PropTypes.object,
  fetchNewAddOn: PropTypes.func.isRequired,
  addOnForFormChanged: PropTypes.func.isRequired,
  ticketTypes: PropTypes.array,
  createAddOn: PropTypes.func.isRequired,
  fetchAddOnToEdit: PropTypes.func.isRequired,
  deleteAddOn: PropTypes.func.isRequired,
  updateAddOn: PropTypes.func.isRequired,
  addOnDragged: PropTypes.func.isRequired,
  addOnSeatingCharts: PropTypes.array,
  autoSaveConfirm: PropTypes.func.isRequired,
  updateConfirm: PropTypes.func.isRequired,
  isEditingAddOnsIntro: PropTypes.bool,
  isEditingAddOnsIntroChanged: PropTypes.func.isRequired,
  addOnsIntroEditorState: PropTypes.object,
  addOnsIntroEditorStateChanged: PropTypes.func.isRequired,
  isLoadingDefaultAddOns: PropTypes.bool,
  isLoadingDefaultAddOnsChanged: PropTypes.func.isRequired,
  isEditingAddOnsAlertMessage: PropTypes.bool,
  isEditingAddOnsAlertMessageChanged: PropTypes.func.isRequired,
  addOnsAlertMessageEditorState: PropTypes.object,
  addOnsAlertMessageEditorStateChanged: PropTypes.func.isRequired,
  manualTaxes: PropTypes.array,
  manualTaxShouldBeChecked: PropTypes.func.isRequired,
  addOnAdded: PropTypes.func.isRequired,
  seatingChartEvents: PropTypes.array.isRequired,
  reloadAddOns: PropTypes.func.isRequired,
  confirmChanged: PropTypes.func.isRequired,
  addOnSeatingChartEvent: PropTypes.object,
  addOnSeatingChartEventChanged: PropTypes.func.isRequired,
  seatingChartEventsChanged: PropTypes.func,
  canEditSeatingChart: PropTypes.func.isRequired,
  reasonWeCannotEditSeatingChart: PropTypes.func.isRequired,
  addOnsIntroTemplates: PropTypes.array,
  addOnsAlertMessageTemplates: PropTypes.array,
  addOnsIntroTemplateDraft: PropTypes.object,
  addOnsAlertMessageTemplateDraft: PropTypes.object,
  addOnMessageTemplateChanged: PropTypes.func.isRequired,
  createAddOnMessageTemplate: PropTypes.func.isRequired,
  deleteAddOnMessageTemplate: PropTypes.func.isRequired
};

export default AddOnsTab;
